<template>
  <div>
    <Pos_add_promotion/>
  </div>
</template>

<script>
import Pos_add_promotion from "@/components/adminArin/pos_system/warehouse/manage_promotion/Pos_add_promotion";
export default {
  name: "PosAddPromotion",
  components: {
    Pos_add_promotion
  }
}
</script>

<style scoped>

</style>
